import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import Button from 'shared/modules/common/components/atoms/Button';
import Dialog from 'shared/modules/common/components/atoms/Dialog';

type Props = {
  open: boolean;
  onCloseButtonPress: () => void;
  onTryButtonPress: () => void;
};

const TimeOutErrorModal = (props: Props) => {
  const isBigScreen = useMediaQuery({ minWidth: 768 });

  return (
    <Dialog
      title="エラーが発生しました"
      titleAlignment="left"
      open={props.open}
      onClose={props.onCloseButtonPress}
      showCloseButton={false}
      style={style.root}
    >
      <Text style={style.text}>
        しばらく時間をおいてからもう一度お試しください。
      </Text>
      <View style={isBigScreen && style.buttonGroupBigScreen}>
        <Button
          title="もう一度試す"
          onPress={props.onTryButtonPress}
          style={[style.button, isBigScreen && style.buttonBigScreen]}
          id="timeout-error-continue-button"
        />
        <Button
          variant="outlined"
          title="キャンセル"
          onPress={props.onCloseButtonPress}
          style={isBigScreen && style.buttonBigScreen}
          id="timeout-error-close-button"
        />
      </View>
    </Dialog>
  );
};

const style = StyleSheet.create({
  root: {
    width: '100%',
    maxWidth: 656,
  },
  text: {
    fontSize: 13,
    color: '#1C1C1C',
    marginBottom: 24,
  },
  buttonGroupBigScreen: {
    flexDirection: 'row',
    marginHorizontal: -8,
  },
  button: {
    marginBottom: 16,
  },
  buttonBigScreen: {
    maxWidth: 296,
    marginHorizontal: 8,
    marginBottom: 0,
  },
});

export default TimeOutErrorModal;
